import { ReactComponent as EditIcon } from '@/assets/icons/ri-edit-line.svg';
import { ReactComponent as CopyIcon } from '@/assets/icons/ri-file-copy-line.svg';
import Button from '@/components/common/Button';
import { currencyFormat, getLongDateFormat } from '@/utils';

export const renderTableTitle = ({ couponTitle, couponCode }: CouponTableTitleParams) => (
	<div className="flex flex-col pr-7 gap-3">
		<div className="flex p-0">
			<p className="text-sm font-bold text-black-primary">{couponTitle}</p>
		</div>
		<div className="flex flex-row justify-between items-center px-3 py-2 gap-4 bg-grey-subtle rounded-sm"
				 role="button"
				 tabIndex={0}
				 onClick={() => navigator.clipboard.writeText(couponCode)}
				 onKeyDown={() => navigator.clipboard.writeText(couponCode)}>
			<p>{couponCode}</p>
			<CopyIcon/>
		</div>
	</div>
)
export const renderTableDiscountType = ({ discountType, discountAmount, maxDiscount}: CouponTableDiscountParams) => {
	const map = {
		PERCENT: {
			textColor: 'text-green-secondary',
			discText: 'Max disc. amount'
		},
		FIXED_DISCOUNT: {
			textColor: 'text-blue-light',
			discText: 'Disc. Amount'
		}
	}

	return (
		<div className='flex flex-col gap-3 p-0'>
			<p className={`font-bold text-sm ${map[discountType]?.textColor}`}>{discountType}</p>
			<div className="flex flex-col p-0 gap-1">
				<p className="font-medium text-small text-grey-dark">Disc. Amount</p>
				<p className="text-sm text-black-primary">{ discountType === "PERCENT" ? `${discountAmount}%` : currencyFormat(discountAmount)}</p>
			</div>

			{ 
			(discountType === "PERCENT" ) &&
			<div className="flex flex-col p-0 gap-1">
				<p className="font-medium text-small text-grey-dark">Max Disc. Amount</p>
				<p className="text-sm text-black-primary">{currencyFormat(maxDiscount)}</p>
			</div>
			}
		</div>
	)
}
export const renderTableQuota = ({ remaining, max }: CouponTableQuotaParams) => {
	const used = max - remaining
	const usedPercent = max === 0 ? 0 : (max - remaining)/max * 100
	const barColor = used === max ? 'bg-red-primary' : 'bg-turquoise-secondary'
	return (
		<div className="flex flex-col p-0 gap-3">
			<p className="text-sm text-black-primary">{`${used} / ${max}`}</p>
			<div className="w-full bg-grey-line-subtle rounded-full h-2.5">
				<div className={`h-2.5 rounded-full ${barColor}`} style={{ width: `${usedPercent}%`}}/>
			</div>
		</div>
	)}
export const renderTablePeriod = ({ startDate, endDate }: CouponTablePeriodParams) => (
	<div className="flex flex-col p-0 gap-3">
		<div className="flex flex-col items-start p-0 gap-1">
			<p className="font-medium text-small text-grey-dark">Start Date</p>
			<p>{`${getLongDateFormat(Number(startDate))}`}</p>
		</div>
		<div className="flex flex-col items-start p-0 gap-1">
			<p className="font-medium text-small text-grey-dark">End Date</p>
			<p>{`${getLongDateFormat(Number(endDate))}`}</p>
		</div>
	</div>
)

export const renderTableCreatedAt = (createdDate : number) => {
	const date = new Date(createdDate)
	return (
	<div className="flex flex-col p-0 gap-3">
		<div className="flex flex-col items-start p-0 gap-1">
			<p>{date.toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: '2-digit' })}, {new Date(createdDate).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}</p>
		</div>
	</div>
	)
}

export const renderTableVisibility = (status: string) => {
	const bgColor = status === 'PUBLIC' ? 'bg-green-subtle' : 'bg-blue-subtle'
	const textColor = status === 'PUBLIC' ? 'text-green-success' : 'text-blue-lighter'

	return (
		<div className="flex justify-center p-0">
			<div className={`flex justify-center items-center px-4 py-3 gap-3 rounded-sm ${bgColor}`}>
				<p className={`font-medium text-sm ${textColor}`}>{status}</p>
			</div>
		</div>
	)
}
export const renderTableStatus = (status: string) => {
	const bgColor = status === 'ACTIVE' ? 'bg-green-subtle' : 'bg-red-subtle'
	const textColor = status === 'ACTIVE' ? 'text-green-success' : 'text-red-secondary'

	return (
		<div className="flex justify-center p-0">
			<div className={`flex justify-center items-center px-4 py-3 gap-3 rounded-sm ${bgColor}`}>
				<p className={`font-medium text-sm ${textColor}`}>{status}</p>
			</div>
		</div>
	)
}
export const renderTableEditButton = (v: { id: string, startDate?: number, endDate?: number }, showModal: Function) => (
	<div>
		<Button
			className="border border-grey-line-subtle"
			type='button'
			variant='basic'
			onClick={() => showModal(v.id, v.startDate, v.endDate)}>
			<EditIcon/>
			Edit
		</Button>
	</div>
)
